import { markUserBlockedInMock } from './users';

// Mock of the «Bloquear» WRITE: simulate latency, then move the shared users fixture to blocked, so
// a follow-up searchUsersByPhoneMock returns the blocked hit and the ficha repaints. A courier
// account's reason is handed on for its trace line. Idempotent. No error-injection hook, like its
// write siblings: error-path component tests inject a failing fn directly via DI.
export async function blockUserMock(id: string, reason?: string): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  markUserBlockedInMock(id, reason);
}
